// gatsby-browser.js
import wrapWithProvider from './wrap-with-provider';
export const wrapRootElement = wrapWithProvider;
